import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { FormaDePagamento } from '@app/models/forma-de-pagamento.model';

import { FormaDePagamentoService } from '@app/services/forma-de-pagamento.service';

@Component({
  selector: 'app-forma-de-pagamento-form',
  templateUrl: './forma-de-pagamento-form.component.html'
})
export class FormaDePagamentoFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  formaDePagamento: FormaDePagamento = new FormaDePagamento();
  titulo: string;
  lstErros: string[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formaDePagamentoService: FormaDePagamentoService,
  ) {
    this.formaDePagamento = new FormaDePagamento();
    this.formaDePagamento.Id = 0;
    this.formaDePagamento.Ativo = true;
    this.formaDePagamento.CreditoDebito = 'A';
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      let id = params['id'];
      this.titulo = id ? 'Editar Forma de Pagamento' : 'Nova Forma de Pagamento';

      if (!id)
        return;

      this.formaDePagamentoService.obterPorId(id).toPromise().then(
        data => this.formaDePagamento = data,
        () => this.router.navigate(['./configuracoes/forma-de-pagamento']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.formaDePagamentoService.gravar(this.formaDePagamento).toPromise().then(
      () => this.router.navigate(['./configuracoes/forma-de-pagamento']),
      (data: any) => {
        if (data.error){
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
